import Vue from 'vue';
import Router from 'vue-router';
import authService from '@/services/AuthService';
import store from '@/store';

import Home from '@/views/home/Home';
import Sig from '@/views/sig/SIG.vue';
import Pessoa from '@/views/pessoa/Pessoa';
import CadastrarPessoaArgentina from '@/views/pessoa-argentina/cadastrar/index';
import DiagnosticoSocioambiental from '@/views/diagnostico-socioambiental/DiagnosticoSocioambiental';
import Laudos from '@/modules/laudos/views/Laudos.vue';
import Usuarios from '@/views/usuarios/Usuarios';
import Inteligencia from '@/views/inteligencia/Inteligencia';
import CompartilhamentoDados from '@/views/compartilhamento-dados/CompartilhamentoDados';

import Territorio from '@/views/territorio/Territorio';
import TerritorioArgentina from '@/views/territorio/TerritorioArgentina';
import VizualizarTerritorioValidacaoAR from '@/views/territorio/VizualizarTerritorioValidacaoAR';
import CadastroTerritorio from '@/views/territorio/CadastroTerritorioInicial';
import VisualizarTerritorio from '@/views/territorio/VisualizarTerritorio';
import DiagnosticoSocioambientalTerritorio from '@/views/territorio/DiagnosticoSocioambientalTerritorio';
import PreAnaliseCredito from '@/modules/pre-analise-credito/views/PreAnaliseCredito';

import VisualizarPreAnaliseCredito from '@/modules/pre-analise-credito/views/VisualizarPreAnaliseCredito';
import Monitoramento from '@/views/monitoramento/Monitoramento';
import MonitoramentoAgricola from '@/views/monitoramento/agricola/MonitoramentoAgricola';
import MonitoramentoSocioambiental from '@/views/monitoramento/socioambiental/MonitoramentoSocioambiental';
import AreaMonitorada from '@/views/monitoramento/AreaMonitorada';
import CadastrarMonitoramentoSocioAmbiental from '@/views/monitoramento/socioambiental/CadastrarMonitoramentoSocioAmbiental.vue';
import ListaTerritoriosImportados from '@/views/monitoramento/ListaTerritoriosImportados';
import VisualizarMonitoramentoSocioambiental from '@/views/monitoramento/socioambiental/VisualizarMonitoramentoSocioambiental';

import VisualizarInteligenciaCarbono from '@/views/inteligencia-carbono/VisualizarInteligenciaCarbono';
import VisualizarCarbonoImovel from '@/views/inteligencia-carbono/VisualizarCarbonoImovel';

import RastreabilidadeSucursales from '@/views/sucursales/Rastreabilidade';
import PersonaSucursales from '@/views/sucursales/Pessoa';
import TerritorioSucursales from '@/views/sucursales/Territorio';
import TerritorioSucursalesAcoes from '@/views/sucursales/Acoes';
import VizualizarContratoSucursales from '@/views/sucursales/VizualizarContrato';
import PreencherContratoSucursales from '@/views/sucursales/PreencherContrato';

import ListaOperacao from '@/views/operacao/Operacao';
import MonitoramentoOperacao from '@/views/operacao/MonitoramentoOperacao';
import FiscalizacaoOperacao from '@/views/operacao/fiscalizacao/FiscalizacaoOperacao';
import DashboardOperacao from '@/views/operacao/DashboardOperacao';
import AnalisarOperacao from '@/views/operacao/AnalisarOperacao';
import CadastroOperacao from '@/views/operacao/CadastrarOperacao';
import VisualizarOperacao from '@/views/operacao/VisualizarOperacao';

import Relatorios from '@/views/admin/relatorios/Relatorios';

import constratosOriginacao from './contratos-originacao';
import diagnosticosSocioambientais from './diagnosticos-socioambientais';

import certificacao from './certificacao';

import relatorioRastreabilidade from './relatorioRastreabilidade';
import laudosRoutes from '@/modules/laudos/routes';
import relatorioExportacaoRoutes from '@/modules/relatorio-exportacao/routes';

import CadastroTerritorioArgentina from '@/views/territorio-argentina/cadastrar/index.vue';

Vue.use(Router);
const router = new Router({
    routes: [
        {
            path: '*',
            redirect: '/'
        },
        {
            path: '/',
            name: 'Home',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: perfilAnalista()
                ? Laudos
                : perfilAdmVEGA()
                ? Relatorios
                : Home
        },
        {
            path: '/sig',
            name: 'SIG',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: Sig
        },
        {
            path: '/pessoa/:cadastrar?',
            name: 'Pessoa',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: Pessoa
        },
        {
            path: '/pessoa/:cadastrar?',
            name: 'Pessoa',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: Pessoa
        },
        {
            path: '/persona/regristion',
            name: 'CadastrarPessoaArgentina',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: CadastrarPessoaArgentina
        },
        {
            path: '/territorio',
            name: 'Territorio',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: Territorio
        },
        {
            path: '/argentina/territorio',
            name: 'TerritorioArgentina',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: TerritorioArgentina
        },
        {
            path: '/argentina/territorio/vizualizar-validacao/:idTerritorio',
            name: 'VizualizarTerritorioValidacaoAR',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: VizualizarTerritorioValidacaoAR
        },
        {
            path: '/territorio/cadastrar-editar',
            name: 'CadastrarEditarTerritorio',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: CadastroTerritorio
        },

        // NOVO CADASTRO TERRITORIO ARGENTINA
        {
            path: '/argentina/territorio/cadastrar',
            name: 'CadastroTerritorioArgentina',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: CadastroTerritorioArgentina
        },

        {
            path: '/territorio/socioambiental/:idTerritorio',
            name: 'TerritorioSocioambiental',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: DiagnosticoSocioambientalTerritorio
        },
        {
            path: '/territorio/:idTerritorio',
            name: 'VisualizarTerritorio',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: VisualizarTerritorio
        },
        {
            path: '/diagnostico-socioambiental/:pesquisa?',
            name: 'DiagnosticoSocioambiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: DiagnosticoSocioambiental
        },
        {
            path: '/usuarios',
            name: 'Usuarios',
            meta: {
                roles: ['ROLE_ADMINISTRATOR']
            },
            component: Usuarios
        },
        {
            path: '/monitoramento',
            name: 'Monitoramento',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_FEATURE_MONITORAMENTO',
                    'ROLE_REGULAR'
                ]
            },
            component: Monitoramento
        },
        {
            path: '/sucursales/territorio',
            name: 'TerritorioSucursales',
            meta: {
                roles: ['ROLE_FEATURE_REVENDA_SUCURSALES_AR']
            },
            component: TerritorioSucursales
        },
        {
            path: '/sucursales/territorio-actions',
            name: 'TerritorioSucursalesAcoes',
            meta: {
                roles: ['ROLE_FEATURE_REVENDA_SUCURSALES_AR']
            },
            component: TerritorioSucursalesAcoes
        },
        {
            path: '/sucursales/rastreabilidade',
            name: 'RastreabilidadeSucursales',
            meta: {
                roles: ['ROLE_FEATURE_REVENDA_SUCURSALES_AR']
            },
            component: RastreabilidadeSucursales
        },
        {
            path: '/sucursales/pessoas',
            name: 'PersonaSucursales',
            meta: {
                roles: ['ROLE_FEATURE_REVENDA_SUCURSALES_AR']
            },
            component: PersonaSucursales
        },
        {
            path: '/sucursales/vizualizar-contrato/:numeroContrato',
            name: 'VizualizarContratoSucursales',
            meta: {
                roles: ['ROLE_FEATURE_REVENDA_SUCURSALES_AR']
            },
            component: VizualizarContratoSucursales
        },
        {
            path: '/sucursales/preencher-contrato/:numeroContrato',
            name: 'PreencherContratoSucursales',
            meta: {
                roles: ['ROLE_FEATURE_REVENDA_SUCURSALES_AR']
            },
            component: PreencherContratoSucursales
        },
        {
            path: '/monitoramento/area-monitorada/:idAreaMonitorada',
            name: 'AreaMonitorada',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_AGRICOLA',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL',
                    'ROLE_FEATURE_MONITORAMENTO',
                    'ROLE_REGULAR'
                ]
            },
            component: AreaMonitorada
        },
        {
            path: '/monitoramento/socioambiental',
            name: 'MonitoramentoSocioambiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL'
                ]
            },
            component: MonitoramentoSocioambiental
        },
        {
            path: '/monitoramento/socioambiental/:idAreaMonitorada',
            name: 'VisualizarMonitoramentoSocioambiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL',
                    'ROLE_REGULAR'
                ]
            },
            component: VisualizarMonitoramentoSocioambiental
        },
        {
            path: '/monitoramento/agricola/cadastrar',
            name: 'CadastrarMonitoramentoAgricola',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_AGRICOLA',
                    'ROLE_REGULAR'
                ]
            },
            component: () =>
                import(
                    '@/views/monitoramento/agricola/CadastrarMonitoramentoAgricola'
                )
        },
        {
            path: '/monitoramento/agricola/:id/imovel',
            name: 'MonitoramentoAgricolaImovel',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_FEATURE_COMPARTILHAMENTO_DADOS'
                ]
            },
            component: () =>
                import(
                    '@/views/monitoramento/agricola/VisualizarImovelMonitoramentoAgricola'
                )
        },
        {
            path: '/monitoramento/agricola',
            name: 'MonitoramentoAgricola',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_MONITORAMENTO_AGRICOLA'
                ]
            },
            component: MonitoramentoAgricola
        },
        {
            path: '/monitoramento/socioambiental/cadastrar',
            name: 'CadastrarMonitoramentoSocioAmbiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL',
                    'ROLE_REGULAR'
                ]
            },
            component: CadastrarMonitoramentoSocioAmbiental
        },
        {
            path: '/inteligencia',
            name: 'Inteligencia',
            meta: {
                roles: [
                    'ROLE_INTELIGENCIA',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: Inteligencia
        },
        {
            path: '/visualizar-inteligencia-carbono',
            name: 'InteligenciaCarbono',
            meta: {
                roles: [
                    'ROLE_INTELIGENCIA',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: VisualizarInteligenciaCarbono
        },
        {
            path: '/compartilhamento-dados',
            name: 'CompartilhamentoDados',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_FEATURE_COMPARTILHAMENTO_DADOS'
                ]
            },
            component: CompartilhamentoDados
        },
        {
            path: '/compartilhamento-dados/solicitacao',
            name: 'CompartilhamentoDadosSolicitacao',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_FEATURE_COMPARTILHAMENTO_DADOS'
                ]
            },
            component: () =>
                import('@/components/compartilhamentoDados/SolicitarRelatorio')
        },
        {
            path: '/operacao',
            name: 'operacao',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: ListaOperacao
        },
        {
            path: '/operacao/fiscalizacao',
            name: 'operacaoFiscalizacao',
            meta: {
                roles: [
                    'ROLE_FEATURE_FISCALIZACAO_OPERACAO',
                    'ROLE_ADMINISTRATOR'
                ]
            },
            component: FiscalizacaoOperacao
        },
        {
            path: '/operacao/cadastrar',
            name: 'operacaoCadastrar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CadastroOperacao
        },
        {
            path: '/operacao/dashboard',
            name: 'operacaoDashboard',
            meta: {
                roles: ['ROLE_FEATURE_FEATURE_OPERACAO', 'ROLE_ADMINISTRATOR']
            },
            component: DashboardOperacao
        },
        {
            path: '/operacao/:id',
            name: 'operacaoVisualizar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: VisualizarOperacao
        },
        {
            path: '/operacao/:id/editar',
            name: 'operacaoEditar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CadastroOperacao
        },
        {
            path: '/operacao/:id/clonar',
            name: 'operacaoClonar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CadastroOperacao
        },
        {
            path: '/operacao/:id/analisar',
            name: 'operacaoAnalisar',
            meta: {
                roles: ['ROLE_FEATURE_OPERACAO', 'ROLE_OPERACAO_APROVADOR']
            },
            component: AnalisarOperacao
        },
        {
            path: '/operacao/:id/monitoramento',
            name: 'operacaoMonitoramento',
            meta: {
                roles: ['ROLE_FEATURE_OPERACAO', 'ROLE_OPERACAO_APROVADOR']
            },
            component: MonitoramentoOperacao
        },
        {
            path: '/admin/relatorios',
            name: 'adminRelatorios',
            meta: {
                roles: ['ROLE_VEGA_ADMIN']
            },
            component: perfilAdmVEGA() ? Relatorios : Home
        },
        {
            path: '/visualizar-carbono-imovel',
            name: 'CarbonoImovel',
            meta: {
                roles: [
                    'ROLE_INTELIGENCIA',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: VisualizarCarbonoImovel
        },
        {
            path: '/lista-territorios-importados',
            name: 'ListaTerritoriosImportados',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: ListaTerritoriosImportados
        },
        {
            path: '/pre-analise-credito',
            name: 'PreAnaliseCredito',
            meta: {
                roles: [
                    'ROLE_FEATURE_PRE_ANALISE_CREDITO',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: PreAnaliseCredito
        },
        {
            path: '/pre-analise-credito/:cpfCnpj',
            name: 'VisualizarPreAnaliseCredito',
            meta: {
                roles: [
                    'ROLE_FEATURE_PRE_ANALISE_CREDITO',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: VisualizarPreAnaliseCredito
        },
        {
            path: '/editar-atalhos',
            name: 'EditarAtalhos',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: () =>
                import('@/components/home/acessoRapido/EditarAtalhos')
        },
        ...constratosOriginacao,
        ...certificacao,
        ...diagnosticosSocioambientais,
        ...relatorioRastreabilidade,
        ...laudosRoutes,
        ...relatorioExportacaoRoutes
    ]
});

function perfilAnalista() {
    let user = sessionStorage.getItem('dadosUsuario');
    if (user && user !== 'null') {
        user = JSON.parse(user);
        return user.isAnalyst;
    }

    return false;
}

function perfilAdmVEGA() {
    let user = sessionStorage.getItem('dadosUsuario');
    if (user && user !== 'null') {
        user = JSON.parse(user);
        return user.isVegaAdmin;
    }

    return false;
}

router.beforeEach((to, from, next) => {
    if (from.fullPath === '/sig') {
        window.stop();
    }

    if (to.query.embedded === 'true') {
        store.dispatch('setEmbeddedMode', true);
    }

    authService
        .isLogged()
        .then(response => {
            store.dispatch('setUsuarioLogado', response.data);

            let isAllowed = false;
            response.data.authorities.forEach(role => {
                if (
                    to.matched.some(route => {
                        return route.meta.roles.includes(role.authority);
                    })
                ) {
                    isAllowed = true;
                }
            });

            return next(isAllowed);
        })
        .catch(() => {
            next(false);
        });
});

export default router;
